export default {"src":"/_next/static/media/DIS.58ca747b.svg","height":18,"width":18};